import { call, put } from 'redux-saga/effects';
import UpdateLeaveActions from '../redux/UpdateLeaveRedux';
import { api } from './api';


export function* updateleavesagas(action: any): Generator<any, void, any> {
  const { leave_id, leave } = action;
  const response = yield call(api.updateLeave, leave_id, leave);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(UpdateLeaveActions.updateLeaveSuccess(response.data));
  } else {
    yield put(UpdateLeaveActions.updateLeaveFailure());
  }
}